import React, { useState } from 'react';
import { Trans, t } from '@lingui/macro';

import Textarea from '$/components/ui/Input/Basics/Textarea';
import CardMain from '$/components/Interactions/cards/CardMain';
import { useCardContext } from '$/components/Interactions/cards/CardContext';

import { emojiList, getEmoji } from '$/utils/emoji';

import { FeedbackIcons } from './FeedbackIcons';
import { InteractionDisplayState } from '../InteractionInfo';
import Form from '$/components/ui/Form';

const FeedBackCard: React.FC = () => {
  const { interaction, attendeeName, isEdit, displayState } = useCardContext();
  const [feedbackSelected, setFeedbackSelected] = useState(interaction.reaction?.numberAnswer ?? 0);
  const [isDisabled, setIsDisabled] = useState(true);
  const { details } = interaction;
  const numberFeedback = emojiList.length;

  switch (displayState) {
    case InteractionDisplayState.Submitted:
    case InteractionDisplayState.Result:
      return (
        <>
          <div className='flex flex-col justify-center rounded-card pt-1e text-center items-center'>
            <CardMain.Emoji emoji={getEmoji(feedbackSelected)} />
            <CardMain.Jumbotron>
              <Trans>
                You rated us <span>{feedbackSelected}</span> out of {numberFeedback}
              </Trans>
            </CardMain.Jumbotron>
            <CardMain.Footer className='font-normal'>
              <Trans>
                Thanks <span className='px-1/4e'>{attendeeName}</span> for your feedback!
              </Trans>
            </CardMain.Footer>
          </div>
        </>
      );

    case InteractionDisplayState.Normal:
      return (
        <>
          <FeedbackIcons
            interaction={interaction}
            setFeedbackSelected={setFeedbackSelected}
            setIsDisabled={setIsDisabled}
            feedbackSelected={feedbackSelected}
            isEdit={isEdit}
          />
          <Form.Field
            name='stringAnswer'
            className={`w-full ${!feedbackSelected ? 'hidden' : ''}`}
            component={
              <Textarea
                autoFocus={Boolean(feedbackSelected)}
                placeholder={`${t`Share your thoughts here`}...`}
                maxLength={512}
              />
            }
          />
          <CardMain.SubmitButton disabled={isDisabled}>
            {details?.buttonText || t`Submit`}
          </CardMain.SubmitButton>
        </>
      );
  }
};

export default FeedBackCard;
